export default __webpack_public_path__ + "assets/svg/BodyWeight.6242f0358442b3880c47a5a4f25579d7.svg";